import React from "react";
import logo from "./../../assets/logo.png";
import "./Landing.css";
import NavButtons from "./nav-buttons/NavButtons";
import Titles from "./titles/Titles";

function Landing() {
  return (
    <header className="app-header">
      <div className="app-container landing-container">
        <img
          src={logo}
          alt="Git Versioniser Logo"
          style={{
            width: "13rem",
            height: "13rem",
            pointerEvents: "none",
          }}
        />
        <Titles />
        <NavButtons />
      </div>
    </header>
  );
}

export default Landing;
